import { useEffect } from 'react';
import { usePublicConfigContext } from '@/core/contexts/PublicConfigContext';
import { initNewRelic } from '@/core/newrelic';

/**
 * Component that initializes New Relic when public config is loaded
 * Should be placed high in the component tree (in App.tsx)
 * Uses requestIdleCallback to defer initialization and avoid blocking render
 */
export function NewRelicInitializer() {
  const { config, isLoading } = usePublicConfigContext();

  useEffect(() => {
    if (!isLoading && config?.newRelic) {
      // Defer New Relic init to avoid blocking initial render
      const init = () => initNewRelic(config.newRelic);
      
      if ('requestIdleCallback' in window) {
        requestIdleCallback(init, { timeout: 3000 });
      } else {
        // Fallback for browsers without requestIdleCallback
        setTimeout(init, 1000);
      }
    }
  }, [config, isLoading]);

  return null;
}




